import { render, staticRenderFns } from "./StatisticFilter.vue?vue&type=template&id=4ba387ec"
import script from "./StatisticFilter.vue?vue&type=script&lang=ts"
export * from "./StatisticFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports